import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import drLogo from '../assets/DR_SOLIDBG.jpg';
import flutterLogo from '../assets/flutterLogo.png'

const title = 'RE-WORD';
const slogan = 'Re-Think. Re-Use. Re-Word!';

const AlphaLandingPage: React.FC = () => {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const totalAnimationTime = 500 * title.length + 1000 + 1000 + 2000;
    const timer = setTimeout(() => setShowMessage(true), totalAnimationTime);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
        color: 'var(--text-normal)',
        backgroundColor: 'var(--background)',
        textAlign: 'center',
      }}
    >
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        {title.split('').map((char, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: -100, scale: 0, rotate: i % 2 === 0 ? -30 : 30 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotate: 0 }}
            transition={{ delay: i * 0.5, type: 'spring', stiffness: 300 }}
            style={{ fontSize: '3rem', fontWeight: 'bold', color: 'var(--text-header)' }}
          >
            {char}
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 * title.length + 1, type: 'spring', stiffness: 120 }}
        style={{ marginTop: '1.5rem', fontSize: '1.5rem', color: 'var(--text-normal)' }}
      >
        {slogan}
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 * title.length + 3 }}
        style={{ display: 'flex', gap: '2rem', marginTop: '2rem' }}
        >
        <img src={flutterLogo} alt="Flutter Logo" style={{ width: 40 }} />
        <img src={drLogo} alt="Digital Relics Logo" style={{ width: 40, borderRadius: 4 }} />
        </motion.div>

      <AnimatePresence>
        {showMessage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            style={{ marginTop: '3rem', fontSize: '1.25rem' }}
          >
            Re-Word Game is currently in a closed Alpha test.<br />
            We’re working hard to bring the full experience to you soon!
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AlphaLandingPage;
